import { mapGetters } from 'vuex';
import motime from '@/common/utilities/motime';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';

export default {
    name: 'propertySchedule',
    inject: ['$eventBus'],
    props: {
        maxDay: {
            type: Number,
            default: 14,
        },
    },
    data() {
        return {
            openHousesButtons: [],
            scheduleTourButtons: [],
            dateList: [],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'hasAgent', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
        hasOpenHouses() {
            return this.dpp.openHouses && this.dpp.openHouses.length;
        },
    },
    components: {
        mvtShifter,
    },
    mounted() {
        if (this.dpp.openHouses && this.dpp.openHouses.length) {
            this.openHousesButtons = this.dpp.openHouses.reduce((acc, openhouse) => {
                if (openhouse.date && openhouse.startTime) {
                    const isVirtual = openhouse.remarks && /virtual/i.test(openhouse.remarks);
                    const start = motime.toDateTime(openhouse.date, openhouse.startTime);
                    const end = motime.toDateTime(openhouse.date, openhouse.endTime);
                    const weekText = motime.toWeekDay(start);
                    const dateText = motime.formatDate(start, { month: 'short', day: 'numeric', raw: true });
                    var time = [];
                    if (!isNaN(start)) {
                        time.push(motime.formatDate(start, { hour: 'numeric', minute: 'numeric', raw: true })?.replace(/\s/g, ''));
                    }
                    if (!isNaN(end)) {
                        time.push(motime.formatDate(end, { hour: 'numeric', minute: 'numeric', raw: true })?.replace(/\s/g, ''));
                    }
                    const timeText = `${time.join(' - ')}`;
                    acc.push({
                        start: start,
                        end: end,
                        isVirtual: isVirtual,
                        weekText: weekText,
                        dateText: dateText,
                        timeText: timeText,
                    });
                }
                return acc;
            }, []);
        }

        //make a loop from today to maxDay
        for (let i = 0; i < this.maxDay; i++) {
            const date = new Date();
            date.setDate(date.getDate() + i);
            this.scheduleTourButtons.push({
                start: date,
                end: null,
                isVirtual: true,
                weekText: motime.toWeekDay(date),
                dateText: motime.formatDate(date, { month: 'short', day: 'numeric', raw: true }),
                timeText: '',
            });
        }
        this.$eventBus.$on('property-openhouse', (options) => {
            if (this.openHousesButtons.length) {
                this.openHotlead(this.openHousesButtons[0], options);
            } else {
                this.openHotlead(null, options);
            }
        });
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),

        openHotlead(openhouse, options) {
            if (!options || !options.hotleadType) {
                console.error('openHotlead: options or options.hotleadType is required');
                return null;
            }
            let opt = {
                propertyId: this.dpp.propertyId,
                propertyData: this.dpp,
                showComment: false,
            };
            if (openhouse) {
                opt.date = openhouse.start;
                opt.time = openhouse.timeText;
                let dateText = openhouse.weekText + '., ' + openhouse.dateText.replace(/(\w+)\s+(\d+)/, '$1. $2');
                opt.hotleadSub = '<b class="text-bold">' + dateText + '</b>';
            }
            if (this.glb.agent.id) {
                opt.ojoFormConfigs = {
                    showCtaLinks: false,
                    showOJOagentInfo: true,
                    showDisclaimer: false,
                    commnetLabel: 'Message',
                };
            }
            if (openhouse) {
                this.$eventBus.$emit('dialog-center', {
                    name: 'mvtHotleadForm',
                    trigger: this.$options.name,
                    opt: {
                        ...opt,
                        hotleadType: options.hotleadType,
                        hotleadTitle: this.molang('dpp.hotButton.scheduleTour'),
                        buttonText: this.molang('dpp.hotleadForm.submit'),
                        hideProfile: true,
                    },
                });
            } else {
                this.$eventBus.$emit('property-pop-schedule', {
                    hideProfile: true,
                    optionalDate: true,
                    hotleadType: options.hotleadType,
                    changeDate: true,
                    trigger: this.$options.name,
                    showFormatAddress: false,
                    hotleadTitle: this.molang('dpp.hotButton.scheduleTour'),
                    buttonText: this.molang('dpp.hotleadForm.submit'),
                });
            }
        },
    },
};
